export default "__VITE_ASSET__BVleME4M__";